import React from "react";

// Styling
import "../../Styles/MainPage.scss";

//components
import NavbarNotification from "./NavbarNotification";
// import NavbarEnterpriseToken from "./NavbarEnterpriseToken";

const NavbarIcons = () => {
  return (
    <div className="__navbarIcons">
      <NavbarNotification />
      {/* <NavbarEnterpriseToken /> */}
    </div>
  );
};

export default NavbarIcons;
